import React, { useState, useEffect } from "react";
import Button from "./Button";

interface ModalProps {
  isOpen: boolean;
  onClose?: () => void;
  children: React.ReactNode;
  size?: "small" | "medium" | "large" | "xlarge" | "screen";
  position?: "center" | "leftFull" | "rightFull" | "bottom";
  backdropClosable?: boolean;
  enterFrom?: "left" | "right" | "top" | "bottom";
  backdrop: boolean;
  modalTitle: string | React.ReactNode;
  confirmText?: string;
  isLoading?: boolean;
  isValid?: boolean;
  cancelText?: string;
  onSubmit?: (event?: React.FormEvent) => void;
  scroll?: boolean;
  modalCustomClass?: string;
  modalHeaderClass?: string;
  modalBodyClass?: string;
  modalTitleClass?: string;
  confirmBtnModalClass?: string;
  submitWrapperClass?: string;
  modalDynamicBtnTitle?: string | React.ReactNode;
  modalDynamicBtnTitleClass?: string;
  onCloseHandler?: () => void;
  showBottomaModal?: boolean;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  children,
  size = "medium",
  backdropClosable = true,
  enterFrom = "top",
  backdrop,
  position,
  modalTitle,
  confirmText = "تایید",
  isLoading,
  isValid,
  cancelText = "انصراف",
  onSubmit,
  scroll,
  modalCustomClass,
  modalHeaderClass,
  modalBodyClass,
  modalTitleClass,
  submitWrapperClass,
  confirmBtnModalClass,
  modalDynamicBtnTitle,
  modalDynamicBtnTitleClass,
  showBottomaModal = true,
  onCloseHandler,
}) => {
  const [isAnimating, setIsAnimating] = useState(false);
  const [shouldRender, setShouldRender] = useState(isOpen);

  useEffect(() => {
    if (isOpen) {
      setShouldRender(true);
      setTimeout(() => setIsAnimating(true), 50);
      // if (typeof window !== "undefined") {
      //   document.body.classList.toggle("overflow-hidden", isOpen);
      // }
    } else {
      setIsAnimating(false);
      setTimeout(() => setShouldRender(false), 100);
      // if (typeof window !== "undefined") {
      //   document.body.classList.remove("overflow-hidden");
      // }
    }
  }, [isOpen]);

  if (!shouldRender) return null;

  const enterClasses = {
    left: "transform translate-x-[-100%] opacity-10",
    right: "transform -translate-x-[-100%] opacity-10",
    top: "transform translate-y-[-100%] opacity-10",
    bottom: "transform -translate-y-[-100%] opacity-10",
  };

  const enterActiveClasses = {
    left: "transform translate-x-0",
    right: "transform translate-x-0",
    top: "transform translate-y-0",
    bottom: "transform translate-y-0",
  };

  const exitClasses = {
    left: "transform -translate-x-[100%] opacity-10",
    right: "transform translate-x-[100%] opacity-10",
    top: "transform -translate-y-[100%] opacity-10",
    bottom: "transform translate-y-[100%] opacity-10",
  };

  const backdropClass = `w-screen h-screen z-[1040] flex items-center justify-center bg-black opacity-40 fixed inset-0 transition-opacity duration-300 ${
    isAnimating ? "opacity-40" : "opacity-0"
  }`;
  const modalClass = `${
    position === "center"
      ? "top-20 left-[50%] -translate-x-[50%] rounded-lg"
      : position === "leftFull"
      ? "left-0 top-0 bottom-0 w-[300px] rounded-tr-xl rounded-br-xl"
      : position === "rightFull"
      ? "right-0 top-0 bottom-0 w-[300px] rounded-tl-xl rounded-bl-xl"
      : position === "bottom"
      ? "bottom-0 right-0 left-0 top-auto bottom-0 w-full rounded-tl-xl rounded-tr-xl"
      : "top-20 left-[50%] -translate-x-[50%]"
  } bg-white shadow-lg fixed transition-transform duration-300 z-[1050] ${
    isAnimating ? enterActiveClasses[enterFrom] : enterClasses[enterFrom]
  } ${!isOpen && !isAnimating ? exitClasses[enterFrom] : ""} ${
    size === "large"
      ? "w-11/12 md:w-3/4 lg:w-2/3"
      : size === "medium"
      ? "w-full md:8/12 lg:w-4/12"
      : size === "small"
      ? "w-full md:w-2/4 lg:w-1/3 2xl:w-1/4"
      : size === "screen"
      ? "w-full h-full top-0 rounded-0"
      : size == "xlarge"
      ? "w-full  sm:w-10/12 lg:w-11/12"
      : ""
  }`;

  const onKeyDownHandler = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      event.preventDefault();
      if (onSubmit) {
        onSubmit();
      }
    }
  };

  return (
    <>
      {backdrop && (
        <div
          className={backdropClass}
          onClick={backdropClosable ? onClose || onCloseHandler : undefined}
        ></div>
      )}
      <form
        onSubmit={onSubmit}
        onKeyDown={onKeyDownHandler}
        className={`${modalClass} min-w-56 min-h-28 modal  ${modalCustomClass}`}
      >
        <div
          className={`flex justify-between py-4 px-3 border-b  ${modalHeaderClass}`}
        >
          <span className={`${modalTitleClass}`}>{modalTitle}</span>
          {onclose ? (
            <button onClick={onClose}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="size-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18 18 6M6 6l12 12"
                />
              </svg>
            </button>
          ) : (
            ""
          )}
        </div>
        <div
          className={`modal-body px-5 ${
            scroll ? "scroll" : ""
          } ${modalBodyClass}`}
        >
          {children}
        </div>
        {onSubmit && showBottomaModal && (
          <>
            <div>
              <span className={`${modalDynamicBtnTitleClass}`}>
                {modalDynamicBtnTitle}
              </span>
              <div
                className={`flex justify-end p-3  gap-3 ${submitWrapperClass}`}
              >
                <Button
                  isLoading={isLoading}
                  type="submit"
                  className={`h-11 px-12 ${confirmBtnModalClass}`}
                  variant="primary"
                  isValid={isValid}
                >
                  {confirmText}
                </Button>

                {onClose && (
                  <Button
                    type="button"
                    className="h-11 px-8"
                    variant="default"
                    onClick={onClose}
                  >
                    {cancelText}
                  </Button>
                )}
              </div>
            </div>
          </>
        )}
      </form>
    </>
  );
};

export default Modal;
